<template>
  <div>
    <gj-table
        ref="gjTable"
        name="saleHotRank"
        :index="false"
        :loading="loading"
        :data="tableData"
        :columns="columns"
        :adapt-height="false"
        :height="534"
        row-id="id"
        :tree-config="{transform: false, lazy: true, hasChild: 'hasChild',loadMethod: loadChildrenMethod}"
    >
      <template v-slot:header:asin>
        <span v-if="type === 'asin'">ASIN</span>
        <span v-if="type === 'variationAsin'">父ASIN/子ASIN</span>
        <span v-if="type === 'msku'">MSKU</span>
      </template>

      <template v-slot:index="{row,index}">
        {{rank(row,index)}}
      </template>

      <template v-slot:picture="{row}">
        <app-dashboard-rank-picture-column
            :row="row"
            :groupType="type"
        ></app-dashboard-rank-picture-column>
      </template>

      <template v-slot:asin="{row}">
        <template v-if="type !== 'msku'">
          <gj-link v-if="row.hasChild" :href="row.variationAsinUrl" target="_blank">{{row.variationAsin | defaultShow}}</gj-link>
          <gj-link v-else :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
        </template>
        <span v-else>{{row.msku | defaultShow}}</span>
      </template>

      <template v-slot:increase="{row}">
        <span class="colorGreen">{{row.increase | defaultShow('','%')}}</span>
      </template>

      <template #empty v-if="!showStoreMask">
        <div></div>
      </template>

    </gj-table>
  </div>
</template>

<script>
import AppDashboardRankPictureColumn
  from "@/views/modules/home/components/rank/components/components/dashboard-rank-picture-column";
import {queryMixin} from "@/minxins";
import {rankMixin} from "@/views/modules/home/components/rank/components/mixin";
import {getPopularityRank} from "@/api/dashboard";
import {mapGetters} from "vuex";

export default {
  name: "app-dashboard-popularity-rank",
  components: {AppDashboardRankPictureColumn},
  mixins: [queryMixin, rankMixin],
  computed: {
    ...mapGetters({
      marketOption: 'marketOption'
    }),
  },
  data() {
    return {
      rankName: 'newPopularity',
      tableData: [],
      columns: [
        {id: 'index', header: '排名', field: 'slot:index', width: '60px'},
        {id: 'marketId', header: '店铺/国家', field: 'option:marketId', width: '100px', options: () => this.marketOption},
        {id: 'picture', header: '图片', field: 'slot:picture', width: '60px'},
        {id: 'title', header: '商品标题', field: 'title', minWidth: '300px', overflowLine: 2},
        {id: 'asin', header: 'slot:asin', field: 'slot:asin', width: '140px'},
        {id: 'fulfillment', header: '渠道', field: 'option:fulfillment', width: '70px', options: () => this.fulfillmentOption},
        {id: 'starLevel', header: '星级', field: 'starLevel',  align: 'right', width: '60px'},
        {id: 'orderProductSales', header: '本月销售额', field: 'orderProductSales',prefix: 'currencySymbol', align: 'right', width: '100px'},
        {id: 'oldOrderProductSales', header: '上月销售额', field: 'oldOrderProductSales', prefix: 'currencySymbol',align: 'right', width: '100px'},
        {id: 'increase', header: '涨幅', field: 'slot:increase',suffix:'%', align: 'right', width: '100px', color:'red'},
      ],
    }
  },
  methods: {
    //异步获取父asin展开数据
    loadChildrenMethod ({ row }) {
      return getPopularityRank({
        currency: this.dashboardCurrency,
        groupType: 'asin',
        month:this.month,
        variationAsin: row.variationAsin,
        marketIds: row.marketId
      })
    },
    $gjQuery() {
      if(!this.showStoreMask){
        return
      }
      // 查询
      this.loading = true;
      getPopularityRank({
        currency: this.dashboardCurrency,
        groupType: this.type,
        month:this.month,
        countrys: this.countryMarket.countryIds.join(','),// 国家
        marketIds: this.countryMarket.marketIds.join(','),// 店铺
      })
          .then((data) => {
            this.tableData = data || [];
            if(this.type === 'variationAsin'){
              this.tableData.forEach((r,index)=>{
                r.hasChild = true;
              })
            }
          })
          .complete(() => this.loading = false);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "common";
/deep/ .vxe-table--render-default .vxe-cell{
  padding-left: 10px;
}
</style>